import Api from '@/services/Index';
import FinanceApi from "@/services/FinanceApi";

const getAll = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_FINANCE;
    return Api.get('/pilotage/payments', config);
}

const get = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_FINANCE;
    return Api.get('/pilotage/payments/' + id);
}

const store = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_FINANCE;
    return Api.post('/pilotage/payments', data);
}

const update = async (id, formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_FINANCE;
    return Api.put('/pilotage/payments/' + id, formData);
}

const del = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_FINANCE;
    return Api.delete('/pilotage/payments/' + id);
}

const exportExcel = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_FINANCE;
    config.responseType = 'arraybuffer'
    return Api.get('/pilotage/payments/excel-export', config);
}

const download = async (id) => {
    // Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return FinanceApi.get('/pilotage/payments/' + id + '/download', {responseType: "arraybuffer"});
}
const excelImport = (formData)=>{
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_FINANCE;
    return Api.post('/pilotage/payments/excel-import',formData)
}

export default {
    getAll,
    get,
    update,
    store,
    del,
    exportExcel,
    download,
    excelImport
}
